import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../header";
import Footer from "../footer";
import { footerData } from "../../constants/company";
import { useScrollToTop } from "../../hooks/useScrollToTop";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  useScrollToTop();
  const { pathname } = useLocation();

  // Fire GA4 page_view on every route change
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_location: window.location.href,
      });
    }
  }, [pathname]);

  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer {...footerData} />
    </>
  );
};

export default Layout;
